import { render } from "./Shuang.vue?vue&type=template&id=1c67bfca"
import script from "./Shuang.vue?vue&type=script&lang=ts"
export * from "./Shuang.vue?vue&type=script&lang=ts"
script.render = render

export default script